window.common = function () {
  $('.select2').select2({
    allowClear: true, 
    placeholder: window.I18n.t('select_option')
  })

  $('.select2-letters-tags').select2({
    allowClear: true,
    placeholder: window.I18n.t('select_option')
  })
}